import axios from 'axios';
import { withRetry } from './apiRetry';
import { sessionRedirect } from './sessionRedirect';
import { tryRefresh } from './refreshToken';

// Always use relative URLs — both preview and production route /api/* to backend
const API_URL = '';

const employeeApi = axios.create({ 
  baseURL: API_URL, 
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' } 
});

employeeApi.interceptors.request.use((config) => { 
  const token = localStorage.getItem('employee_token'); 
  if (token) config.headers.Authorization = `Bearer ${token}`; 
  return config; 
});

// Retry transient failures before giving up
withRetry(employeeApi);

employeeApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    const isAuthCall = /\/auth\/(login|refresh)/i.test(url);
    // Any 401 except the login/refresh POST itself → try silent refresh first.
    if (status === 401 && !isAuthCall && !error.config.__hasRetriedAuth) {
      const newToken = await tryRefresh('employee');
      if (newToken) {
        error.config.__hasRetriedAuth = true;
        error.config.headers.Authorization = `Bearer ${newToken}`;
        return employeeApi.request(error.config);
      }
      // Refresh failed → session is truly dead. Clear + bounce.
      sessionRedirect('employee');
    }
    return Promise.reject(error);
  }
);

export default employeeApi;
